import { AfterContentInit, afterNextRender, ChangeDetectorRef, Component, HostListener, Inject, OnDestroy, TemplateRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { map, startWith, take } from 'rxjs/operators';
import { MainConfiguration } from 'src/business/models/main-configuration.model';
import { ContentCache } from 'src/core-lib/navigation/services/content-cache.service';
import { ChromeService } from 'src/layout/chrome/services/chrome.service';
import { FabService } from 'src/layout/fab/services/fab.service';
import { OverlayService } from 'src/layout/overlay/services/overlay.service';
import { ContentCacheUtils } from 'src/utils/storage.util';
import { Uuid } from 'src/utils/uuid.util';
import { NotificationModel } from './notification/models/notification';
import { NOTIFICATION } from './notification/tokens';





@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],

})
export class AppComponent implements AfterContentInit, OnDestroy {
    @ViewChild('header') header: TemplateRef<any>;
    @ViewChild('footer') footer: TemplateRef<any>;

    inertHeader$: Observable<string | null>;
    inert$: Observable<string | null>;
    inertInvert$: Observable<string | null>;

    pageAlias$: Observable<string>;
    errorCount: number = 0;

    subscriptions: Subscription[];
    @HostListener('navigate', ['$event'])
    navigate(e: CustomEvent) {
        this.router.navigateByUrl(e.detail);
    }


    constructor(
        private detector: ChangeDetectorRef,
        private translateService: TranslateService,
        private router: Router,
        private chromeService: ChromeService,
        private fabService: FabService,
        private overlayService: OverlayService,
        contentCache: ContentCache,
        @Inject(NOTIFICATION)
        private _notifications$: BehaviorSubject<NotificationModel>,
    ) {
        this.subscriptions = [];
        this.subscriptions.push(this.translateService.onLangChange.pipe(take(1)).subscribe(() => this.detector.detectChanges()));
        this.inertHeader$ = this.overlayService.overlay$.pipe(
            map(_ => _ == null || _.classes === 'search-dropdown' || _.classes === 'menu-dropdown' ? null : ''),
            startWith(null)
        );
        this.inert$ = this.overlayService.overlay$.pipe(
            map(_ => _ == null ? null : ''),
            startWith(null)
        );
        this.inertInvert$ = this.inert$.pipe(
            map(_ => _ === '' ? null : '')
        );
        // if (contentCache.get<MainConfiguration>('mainConfiguration')?.scrollToTop) {
        this.fabService.addFab({
            action: () => window.scrollTo(0, 0),
            svg: 'chevron-top',
            style: {
                backgroundColor: 'var(--fab-scroll-to-top-background-color)',
                color: 'var(--fab-scroll-to-top-color)',
                fontSize: '1.3em',
                height: '2em',
                padding: '0.3em .5em .5em',
                transform: 'translateY(-10%)',
            }
        });
        // }
        afterNextRender(() => {
            setTimeout(() => {
                let _url = new URL(window.location.href);
                if (_url.searchParams.has('redirectTo')) {
                    if (_url.searchParams.get('redirectTo') == 'preferedCatalog')
                        this.router.navigateByUrl(ContentCacheUtils.checkout<{ catalogLink: string }>()?.catalogLink ?? window.location.pathname);
                }
            }, 100)
        })
    }



    ngAfterContentInit(): void {
        this.chromeService.setHeader(this.header);
        this.chromeService.setFooter(this.footer);
    }

    results$ = new BehaviorSubject<{ imgUrl: string, text: string, id: string }[]>([]);

    idTrack(index: number, item: { imgUrl: string, text: string, id: string }) {
        return item.id;
    }

    addPage(page: number) {
        this.results$.next(this.results$.value.concat(new Array(8).fill(undefined).map((v, i) => ({
            imgUrl: `https://dummyimage.com/600x400/000/fff.png&text=${Uuid.create()}`,
            text: Uuid.create(),
            id: i + ''
        }))))
    }
    ngOnDestroy(): void {
        this.subscriptions.forEach(sub => {
            if (sub != null && !sub.closed)
                sub.unsubscribe();
        })
    }

}
